import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';

export const searchUserItem = style({
  display: 'flex',
  gap: space.s12,
  cursor: 'pointer',
});

export const searchUserAvatar = style({
  flexShrink: 0,
});
export const searchUserInfo = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s2,
  overflow: 'hidden',
});
export const searchUserName = style({
  ...typography['titleSm'],
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
});
export const searchUserHandle = style({
  ...typography['bodySm'],
  color: themeVars.container.foreground.tertiary,
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
});
